import React from 'react'

// --- IMPORTS DE IMÁGENES (Se mantienen todos exactamente igual) ---
import d20251 from "../assets/d20251.jpeg"
import d20252 from "../assets/d20252.png"
import d20253 from "../assets/equipo4.webp"
import d20241 from "../assets/d20241.png"
import d20242 from "../assets/d20242.jpg"
import d20243 from "../assets/d20243.jpg"
import d20244 from "../assets/d20244.png"
import d20231 from "../assets/d20231.png"
import d20232 from "../assets/d20232.jpg"
import d20235 from "../assets/d20235.jpg"
import d20236 from "../assets/d20236.jpg"
import d20221 from "../assets/d20221.webp"
import d20222 from "../assets/d20222.webp"
import d20223 from "../assets/d20223.webp"
import d20224 from "../assets/d20224.webp"
import d20225 from "../assets/d20225.webp"
import d20211 from "../assets/d20211.webp"
import d20212 from "../assets/d20212.webp"
import d20213 from "../assets/d20213.webp"
import d20214 from "../assets/d20214.webp"
import d20215 from "../assets/d20215.webp"
import d20191 from "../assets/d20191.webp"
import d20192 from "../assets/d20192.webp"
import d20181 from "../assets/d20181.webp"
import d20182 from "../assets/d20182.webp"
import d20171 from "../assets/d20171.webp"
import d20172 from "../assets/d20172.webp"
import d20173 from "../assets/d20173.webp"
import d20161 from "../assets/d20161.webp"
import d20162 from "../assets/d20162.webp"
import d20163 from "../assets/d20163.webp"

export default function ModalPremio(props) {
    if (!props.visible) return null;

    const handleOnClose = (e) => {
        if (e.target.id === "container") props.onClose();
    }

    // Diccionario de datos para evitar duplicar JSX
    const dataByYear = {
        2025: [
            { nombre: "Roberto García Peña", img: d20252, link: "https://drive.google.com/file/d/1UYaVSLsYqFV50CPZTs0_rsTQTRpgsom4/view?usp=sharing" },
            { nombre: "Antonio A García García", img: d20251, link: "https://docs.google.com/document/d/18EAlDuXNwUd6-ToUZSZ8dinzuvUmxkD1/edit?usp=sharing" },
            { nombre: "José Luis Pertuz Cabeza", img: d20253, link: "https://docs.google.com/document/d/1KNx20v17CQ6hwSmTIe5KCGaSVsSAapPv/edit?usp=sharing" }
        ],
        2024: [
            { nombre: "Rdo. Hno. Eduardo Botero Gallego", img: d20242, link: "https://drive.google.com/file/d/1SD2x0_kie6PtxUHIb9tL0y5oS_0cSOmM/view?usp=drive_link" },
            { nombre: "Edgardo Tobias Clavijo Muñoz", img: d20243, link: "https://docs.google.com/document/d/13qdrlQIUK2d0hf_ZkJvsg4PfKWQZKAu2/edit?usp=drive_link" },
            { nombre: "Hector A. Iriarte Martinez", img: d20244, link: "https://drive.google.com/file/d/1op6AX4VrUdRqPUjUOQrFh_1XBepsOlMj/view?usp=drive_link" },
            { nombre: "Int. Rodolfo A. Coneo Martinez", img: d20241, link: "https://docs.google.com/presentation/d/1YgHjDQ_ndB8A3h5sZTx2cAuYgQOZ1y0C/edit?usp=drive_link" }
        ],
        2023: [
            { nombre: "Nestor Albor", img: d20231, link: "https://docs.google.com/document/d/1fRCb83Grc6snLpQEr3AbCjistVfrByCN/edit?usp=sharing" },
            { nombre: "Robinson Peña", img: d20232, link: "https://docs.google.com/document/d/1hx_r9rPWCSgODJ4zLe37QNP4OQ1CqpZ7/edit?usp=sharing" },
            { nombre: "Nubia Huertas", img: d20235, link: "https://docs.google.com/document/d/1CGShKMRPMoo2bcN0ClkZW-uY615mb1N3/edit?usp=sharing" },
            { nombre: "Margarita S.", img: d20236, link: "https://docs.google.com/document/d/1Pt46JOjrLUHMnSWUXufgJLdLhIxI1-DA/edit?usp=sharing" }
        ],
        2022: [
            { nombre: "Manuel Barraza", img: d20221, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_5c62992549a84db4a87aa0ddf4d2b09a.docx?dn=Historia%20docente%20de%20Manuel%20Varela%20Barraza%20NOV%202022.docx" },
            { nombre: "Edgar Heredia", img: d20222, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_5a938ce7ada249f88d7da48fe882d5d1.docx?dn=Edgar%20Heredia%20R%20perfil%20NOV%202022.docx" },
            { nombre: "Diana Fischer", img: d20223, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_c7334778e2d44402abfd19c224264505.docx?dn=Diana%20Fischer%20perfil%20NOV%202022.docx" },
            { nombre: "José M. Perez", img: d20224, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_a8c8b780b0e549ad8fb3a0a9fcc15ec0.docx?dn=JOSE%20MANUEL%20P%C3%89REZ%20SARMIENTO%20Perfil%20de%20docente%20NOV%202022.docx" },
            { nombre: "Reymers Rocha", img: d20225, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_95ddda5eaa89481a852a84b9527c8495.docx?dn=Rymes%20Rocha%20Perfil%20NOV%202022.docx" }
        ],
        2021: [
            { nombre: "Alvaro Bustillo", img: d20211, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_ac8582ab73dc4712b323dd1c82db42dc.pdf" },
            { nombre: "Sergio Niño Arraque", img: d20212, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_2f4f8f5c03fa4f23b7a5e96f6ca1cf0d.docx?dn=Reflexi%C3%B3n%20a%20la%20labor%20docente%20-%20Sergio%20Ni%C3%B1o%20(1).docx" },
            { nombre: "Jesus Acevedo", img: d20213, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_da76c066e6504e17baaa93636f6cc0e3.docx?dn=Biografia%20de%20Jesus%20Acevedo.docx" },
            { nombre: "Justo Vargas", img: d20214, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_f734adf4605543e4ae07ff215f28ffe6.docx?dn=Biografia%20Justo%20Miguel%20Vargas%20Lascarro.docx" },
            { nombre: "Adonay Jaramillo", img: d20215, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_63225936eb354b56ae8a0b47a56455b6.doc?dn=ensayo%20para%20fundaci%C3%B3n%20adonay%20jaramillo.doc" }
        ],
        2019: [
            { nombre: "Fausto Chatela", img: d20191, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_bcbe6d855ba5447a9bba5001e9c6652f.pdf" },
            { nombre: "Carmen Curcio", img: d20192, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_0d3ca6d60b454bc3b0e9bec09bf5fd0d.pdf" }
        ],
        2018: [
            { nombre: "Luis Hoyos", img: d20181, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_25798abf9983469a9d9f79ab25dff0a3.pdf" },
            { nombre: "Maria Eugenia Arias", img: d20182, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_d92d4e3d6b8b4672afbd69ccbe44a50e.pdf" }
        ],
        2017: [
            { nombre: "Naileth Caballero", img: d20171, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_7d707f14519d4bddbb44b0b964f86ba5.pdf" },
            { nombre: "Andreana Heredia", img: d20172, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_7d707f14519d4bddbb44b0b964f86ba5.pdf" },
            { nombre: "Manuel Rios", img: d20173, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_40755b45467a49d7a4481a0f2f945833.pdf" }
        ],
        2016: [
            { nombre: "Eduardo Pulido", img: d20161, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_70fff4839dc546f3839b6ed458bbb67c.pdf" },
            { nombre: "Jorge Moreno", img: d20162, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_57493daa62c94184b32bce1d99ddd1d7.pdf" },
            { nombre: "Claudia Rodríguez", img: d20163, link: "https://239b9cb9-0198-4db4-9261-aee3d4c3dfe9.filesusr.com/ugd/d7a2e5_c9f0f3e64f414ed29e3ef280ee00c020.pdf" }
        ]
    };

    const currentYearData = dataByYear[props.year] || [];

    return (
        <div
            id='container'
            onClick={handleOnClose}
            className='fixed z-[2000] inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4'
        >
            {/* Contenedor Principal del Modal */}
            <div className='relative bg-slate-50 w-full max-w-6xl h-[90vh] md:h-auto md:max-h-[85vh] rounded-[3rem] shadow-2xl overflow-hidden flex flex-col animate-fadeIn'>
                
                {/* Cabecera del Modal */}
                <div className='bg-white px-8 py-6 border-b border-slate-100 flex justify-between items-center sticky top-0 z-10'>
                    <div>
                        <h2 className='text-2xl md:text-3xl font-black text-slate-800'>Ganadores {props.year}</h2>
                        <p className='text-blue-600 font-bold text-xs uppercase tracking-widest mt-1'>Excelencia Pedagógica</p>
                    </div>
                    <button 
                        onClick={props.onClose}
                        className='w-12 h-12 flex items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-red-100 hover:text-red-500 transition-all text-2xl font-bold'
                    >
                        ✕
                    </button>
                </div>

                {/* Grid de Contenido (Scrollable) */}
                <div className='overflow-y-auto p-6 md:p-10'>
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
                        {currentYearData.map((obj, index) => (
                            <div 
                                key={index} 
                                className='group bg-white rounded-[2rem] p-6 shadow-lg border border-slate-100 flex flex-col items-center transition-all duration-300 hover:shadow-2xl hover:-translate-y-2'
                            >
                                {/* Contenedor de Imagen con Efecto */}
                                <div className='relative w-40 h-40 mb-6'>
                                    <div className='absolute inset-0 bg-blue-600 rounded-full blur-lg opacity-0 group-hover:opacity-20 transition-opacity'></div>
                                    <img 
                                        className='w-full h-full object-cover rounded-full border-4 border-slate-50 shadow-md relative z-10' 
                                        src={obj.img} 
                                        alt={obj.nombre} 
                                    />
                                </div>

                                <h3 className='text-xl font-black text-slate-800 text-center mb-2 h-14 flex items-center'>
                                    {obj.nombre}
                                </h3>
                                
                                <div className='w-10 h-1 bg-slate-200 rounded-full mb-6 group-hover:w-20 group-hover:bg-blue-600 transition-all'></div>

                                <a 
                                    target="_blank" 
                                    rel="noreferrer"
                                    href={obj.link} 
                                    className='mt-auto w-full bg-slate-900 text-white text-center py-3.5 rounded-2xl font-bold hover:bg-blue-700 transition-colors shadow-lg shadow-slate-200'
                                >
                                    Conocer más
                                </a>
                            </div>
                        ))}
                    </div>

                    {/* Footer del Modal (Opcional) */}
                    <div className='mt-12 text-center pb-6'>
                        <p className='text-slate-400 text-sm font-medium italic'>
                            "Reconociendo el impacto que transforma vidas."
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}